/**
 * Lego Tabs: theme.recentlyViewed, theme.buildProductImage, Slick (fade, 1 Slick slide = 4 items).
 */
(function () {
  'use strict';

  var RECENT_LIMIT = 15;
  /** Match theme.recentlyViewed + buildProductImage width list (theme.js) */
  var WIDTHS = [180, 360, 540, 720, 900, 1080];

  function getConfig(root) {
    var el = root.querySelector('[data-lego-tabs-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeImageSource(src) {
    if (!src) return null;
    return String(src).replace(/_\{width\}x(?=\.)/, '');
  }

  function getRecentImageSource(handle, recent) {
    if (!recent || !recent[handle] || !recent[handle].featuredImage) {
      return null;
    }
    return normalizeImageSource(recent[handle].featuredImage);
  }

  function getFeaturedImageSource(product, handle, recent) {
    if (!product) return null;
    if (product.featured_image) {
      return normalizeImageSource(
        typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src
      );
    }
    if (product.images && product.images[0]) {
      var first = product.images[0];
      return normalizeImageSource(typeof first === 'string' ? first : first.src);
    }
    return getRecentImageSource(handle, recent);
  }

  function getImageAtSource(product, index) {
    if (!product.images || !product.images[index]) return null;
    var im = product.images[index];
    return normalizeImageSource(typeof im === 'string' ? im : im.src);
  }

  function getAspectRatioPercent(product, handle, recent) {
    if (recent && recent[handle] && recent[handle].aspectRatio) {
      return String(recent[handle].aspectRatio);
    }
    if (product.images && product.images[0] && product.images[0].aspect_ratio) {
      return String(100 / product.images[0].aspect_ratio);
    }
    return '100';
  }

  function applyImageDataToProduct(p, imageSrc, aspectPercent) {
    if (typeof theme === 'undefined' || !theme.Images) return p;
    if (!imageSrc) {
      p.image_responsive_url = '';
      p.image_responsive_urls = [];
      return p;
    }
    var single = theme.Images.buildImagePath(imageSrc);
    var list = theme.Images.buildImagePath(imageSrc, WIDTHS);
    p.image_responsive_url = (single && single[0]) || imageSrc;
    p.image_responsive_urls = list;
    if (theme.settings && theme.settings.productImageSize === 'natural' && aspectPercent) {
      p.image_aspect_ratio = aspectPercent;
    }
    return p;
  }

  function formatProductPrice(product, fromPriceTemplate, strRegular, strSale) {
    if (typeof theme === 'undefined' || !theme.Currency) return '';
    var mf = (theme.settings && theme.settings.moneyFormat) || '{{amount}}';
    var priceMin = Number(product.price_min);
    var priceMax = Number(product.price_max);
    var compare = product.compare_at_price;
    if (compare == null && product.variants && product.variants[0]) {
      compare = product.variants[0].compare_at_price;
    }
    if (Number.isNaN(priceMin) || priceMin < 0) {
      return '';
    }
    var varies = product.price_varies === true || (Number(priceMax) > 0 && priceMin < priceMax);
    if (varies) {
      var fromMoney = theme.Currency.formatMoney(priceMin, mf);
      var t = fromPriceTemplate || 'from {{ price }}';
      var withPrice = t
        .replace('___PRICE___', fromMoney)
        .split('{{ price }}')
        .join(fromMoney);
      return '<div class="grid-product__price">' + withPrice + '</div>';
    }
    var price = theme.Currency.formatMoney(priceMin, mf);
    var inner = price;
    if (compare != null && Number(compare) > priceMin) {
      var cmp = theme.Currency.formatMoney(compare, mf);
      var reg = strRegular || 'Regular price';
      var sal = strSale || 'Sale';
      inner =
        '<span class="visually-hidden">' +
        escapeHtml(reg) +
        '</span><span class="grid-product__price--original">' +
        cmp +
        '</span> <span class="visually-hidden">' +
        escapeHtml(sal) +
        '</span> ' +
        price;
    }
    return '<div class="grid-product__price">' + inner + '</div>';
  }

  function buildProductSlideHtml(root, product, recCtx) {
    var typeStyle = (recCtx && recCtx.typeStyle) || 'body';
    var handle = product.handle;
    var url = product.url || '/products/' + handle;
    if (recCtx && recCtx.recent && recCtx.recent[handle] && recCtx.recent[handle].url) {
      url = recCtx.recent[handle].url;
    }
    var sizes = (root.getAttribute('data-image-sizes') || '(max-width: 768px) 45vw, 18vw').trim();

    if (typeof theme === 'undefined' || !theme.buildProductImage) {
      return '';
    }

    var ar = getAspectRatioPercent(product, handle, recCtx && recCtx.recent);
    var p1 = Object.assign({}, product);
    applyImageDataToProduct(p1, getFeaturedImageSource(product, handle, recCtx && recCtx.recent), ar);
    if (!p1.image_responsive_urls || !p1.image_responsive_urls.length) {
      return '';
    }
    var primary = theme.buildProductImage(p1, sizes);
    var secondary = '';
    if (recCtx && recCtx.hoverSecondary && product.images && product.images.length > 1) {
      var src2 = getImageAtSource(product, 1);
      if (src2) {
        var p2 = Object.assign({}, product);
        applyImageDataToProduct(p2, src2, ar);
        secondary =
          '<div class="grid-product__secondary-image small--hide">' + theme.buildProductImage(p2, sizes) + '</div>';
      }
    }

    return (
      '<div class="lego-tabs__grid-cell" data-product-handle="' +
      escapeHtml(handle) +
      '"><div class="grid-product lego-tabs__grid-product" data-product-handle="' +
      escapeHtml(handle) +
      '"><div class="grid-product__content"><a href="' +
      escapeHtml(url) +
      '" class="grid-product__link"><div class="grid-product__image-mask">' +
      primary +
      secondary +
      '</div><div class="grid-product__meta"><div class="grid-product__title grid-product__title--' +
      escapeHtml(typeStyle) +
      '">' +
      escapeHtml(product.title) +
      '</div>' +
      formatProductPrice(
        product,
        recCtx && recCtx.fromPriceTemplate,
        recCtx && recCtx.strRegularPrice,
        recCtx && recCtx.strSalePrice
      ) +
      '</div></a></div></div></div>'
    );
  }

  function fetchProductJson(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('product');
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function getProductForHandle(handle) {
    if (
      typeof theme !== 'undefined' &&
      theme.recentlyViewed &&
      theme.recentlyViewed.productInfo &&
      theme.recentlyViewed.productInfo[handle]
    ) {
      var pi = theme.recentlyViewed.productInfo[handle];
      if (typeof pi === 'string') {
        try {
          return JSON.parse(pi);
        } catch (e) {
          return null;
        }
      }
      return typeof pi === 'object' ? pi : null;
    }
    return null;
  }

  function getRecentProducts() {
    if (typeof theme === 'undefined' || !theme.recentlyViewed) {
      return {};
    }

    var recent = theme.recentlyViewed.recent || {};
    if (recent && Object.keys(recent).length > 0) {
      return recent;
    }

    try {
      var stored = window.localStorage && window.localStorage.getItem('theme-recent');
      if (!stored) {
        return recent || {};
      }

      var parsed = JSON.parse(stored);
      if (parsed && typeof parsed === 'object') {
        theme.recentlyViewed.recent = parsed;
        return parsed;
      }
    } catch (e) {
      return recent || {};
    }

    return recent || {};
  }

  function collectRecentOrder(recent) {
    var out = [];
    if (!recent || typeof recent !== 'object') return out;
    Object.keys(recent).forEach(function (key) {
      if (key === 'undefined' || !key) return;
      out.unshift({ handle: key });
    });
    return out.slice(0, RECENT_LIMIT);
  }

  function loadRecentContent(root) {
    if (typeof theme === 'undefined' || !theme.recentlyViewed) {
      return Promise.resolve({ html: '' });
    }
    var recent = getRecentProducts();
    var ordered = collectRecentOrder(recent);
    if (ordered.length === 0) {
      return Promise.resolve({ html: '' });
    }
    var config = getConfig(root);
    var recCtx = {
      recent: recent,
      hoverSecondary: root.getAttribute('data-hover-secondary') === 'true',
      typeStyle: root.getAttribute('data-type-product-style') || 'body',
      fromPriceTemplate: config.fromPriceTemplate,
      strRegularPrice: config.strRegularPrice,
      strSalePrice: config.strSalePrice
    };

    var promises = ordered.map(function (o) {
      return fetchProductJson(o.handle).then(function (p) {
        if (p) return p;
        return getProductForHandle(o.handle);
      });
    });

    return Promise.all(promises).then(function (products) {
      var cells = [];
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        if (!p || !p.handle) continue;
        var cell = buildProductSlideHtml(root, p, recCtx);
        if (cell) cells.push(cell);
      }
      return { html: wrapSlickPages(cells) };
    });
  }

  function getCellsPerPage() {
    if (window.innerWidth < 600) {
      return 2;
    }
    if (window.innerWidth < 1024) {
      return 3;
    }
    return 5;
  }

  function wrapSlickPages(cells, cellsPerPage) {
    if (!cells || !cells.length) {
      return '';
    }
    var perPage = cellsPerPage || getCellsPerPage();
    var out = [];
    for (var i = 0; i < cells.length; i += perPage) {
      out.push(
        '<div class="lego-tabs__slick-page">' + cells.slice(i, i + perPage).join('') + '</div>'
      );
    }
    return out.join('');
  }

  function getCarouselCellHtml(carousel) {
    if (carousel._legoTabsCellHtml && carousel._legoTabsCellHtml.length) {
      return carousel._legoTabsCellHtml;
    }

    carousel._legoTabsCellHtml = [].slice
      .call(carousel.querySelectorAll('.lego-tabs__slick-page > .lego-tabs__grid-cell'))
      .map(function (cell) {
        return cell.outerHTML;
      });

    return carousel._legoTabsCellHtml;
  }

  function rebuildCarouselPages(carousel) {
    if (!carousel) {
      return;
    }

    var cells = getCarouselCellHtml(carousel);
    var cellsPerPage = getCellsPerPage();
    if (!cells.length || carousel._legoTabsCellsPerPage === cellsPerPage) {
      return;
    }

    if (typeof jQuery === 'function' && jQuery.fn.slick && jQuery(carousel).hasClass('slick-initialized')) {
      jQuery(carousel).slick('unslick');
    }

    carousel.innerHTML = wrapSlickPages(cells, cellsPerPage);
    carousel._legoTabsCellsPerPage = cellsPerPage;
  }

  function getSlickOptions() {
    return {
      infinite: false,
      fade: true,
      speed: 450,
      cssEase: 'ease-in-out',
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      dots: true,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>'
    };
  }

  function ensureSlick($carousel) {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;
    if (!$carousel || !$carousel.length) return;
    rebuildCarouselPages($carousel[0]);
    if ($carousel.find('.lego-tabs__slick-page').length === 0) return;
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('setPosition');
      return;
    }
    $carousel.slick(getSlickOptions());
    if (window.AOS && typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    }
  }

  function getTabButtons(root) {
    return [].slice.call(root.querySelectorAll('.lego-tabs__nav .lego-tabs__tab[role="tab"]'));
  }

  function getPanels(root) {
    return [].slice.call(root.querySelectorAll('.lego-tabs__panel[data-panel]'));
  }

  var TAB_FADE_MS = 250;

  function shouldReduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ensurePanelCarousel(panel) {
    var c = panel && panel.querySelector('.js-lego-tabs-carousel');
    if (c && typeof jQuery === 'function') {
      setTimeout(function () {
        ensureSlick(jQuery(c));
      }, 0);
    }
  }

  function setActiveTab(root, tabId) {
    getTabButtons(root).forEach(function (btn) {
      var t = btn.getAttribute('data-tab');
      if (t === tabId) {
        btn.setAttribute('aria-selected', 'true');
        btn.setAttribute('tabindex', '0');
      } else {
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      }
    });

    var panels = getPanels(root);
    var targetPanel = null;
    var currentPanel = null;

    panels.forEach(function (p) {
      var pid = p.getAttribute('data-panel');
      if (pid === tabId) {
        targetPanel = p;
      } else if (!p.hasAttribute('hidden')) {
        currentPanel = p;
      }
    });

    if (!targetPanel) {
      return;
    }

    if (root._legoTabsFadeTimer) {
      clearTimeout(root._legoTabsFadeTimer);
    }

    panels.forEach(function (p) {
      p.classList.remove('is-fading');
    });

    if (!currentPanel || currentPanel === targetPanel || shouldReduceMotion()) {
      panels.forEach(function (p) {
        if (p === targetPanel) {
          p.removeAttribute('hidden');
          p.setAttribute('tabindex', '0');
        } else {
          p.setAttribute('hidden', '');
          p.setAttribute('tabindex', '-1');
        }
      });
      ensurePanelCarousel(targetPanel);
      return;
    }

    currentPanel.classList.add('is-fading');

    root._legoTabsFadeTimer = setTimeout(function () {
      panels.forEach(function (p) {
        if (p === targetPanel) {
          p.classList.add('is-fading');
          p.removeAttribute('hidden');
          p.setAttribute('tabindex', '0');
        } else {
          p.setAttribute('hidden', '');
          p.setAttribute('tabindex', '-1');
        }
      });

      targetPanel.offsetHeight;
      requestAnimationFrame(function () {
        targetPanel.classList.remove('is-fading');
        ensurePanelCarousel(targetPanel);
      });
    }, TAB_FADE_MS);
  }

  function getFirstTabId(cfg, root) {
    var order = ['watch', 'learn', 'build', 'paint', 'recent'];
    for (var i = 0; i < order.length; i++) {
      var id = order[i];
      if (id === 'recent' && !cfg.enableRecent) continue;
      if (id === 'learn' && !cfg.hasLearn) continue;
      if (id === 'watch' && !cfg.hasWatch) continue;
      if (id === 'build' && !cfg.hasBuild) continue;
      if (id === 'paint' && !cfg.hasPaint) continue;
      if (root.querySelector('.lego-tabs__tab[data-tab="' + id + '"]')) {
        return id;
      }
    }
    return null;
  }

  function removeRecentTabUI(root) {
    var tab = root.querySelector('.lego-tabs__tab[data-tab="recent"]');
    var panel = root.querySelector('.lego-tabs__panel[data-panel="recent"]');
    if (tab) {
      tab.setAttribute('hidden', '');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    }
    if (panel) {
      panel.setAttribute('hidden', '');
      panel.setAttribute('tabindex', '-1');
    }
  }

  function restoreRecentTabUI(root) {
    var tab = root.querySelector('.lego-tabs__tab[data-tab="recent"]');
    var panel = root.querySelector('.lego-tabs__panel[data-panel="recent"]');
    if (tab) {
      tab.removeAttribute('hidden');
    }
    if (panel) {
      panel.classList.remove('is-loading');
    }
  }

  function hideLegoSectionIfNoTabs(root) {
    if (root.querySelectorAll('.lego-tabs__nav .lego-tabs__tab').length > 0) {
      return;
    }
    var section = root.closest && root.closest('.shopify-section');
    if (section) {
      section.setAttribute('hidden', '');
    } else {
      root.setAttribute('hidden', '');
    }
  }

  function activateDefaultCarousels(root, config) {
    var first = getFirstTabId(
      {
        enableRecent: !!config.enableRecent,
        hasLearn: !!config.hasLearn,
        hasWatch: !!config.hasWatch,
        hasBuild: !!config.hasBuild,
        hasPaint: !!config.hasPaint
      },
      root
    );
    if (first) {
      setActiveTab(root, first);
    } else {
      hideLegoSectionIfNoTabs(root);
    }
  }

  function bindTabDelegation(root) {
    var nav = root.querySelector('.lego-tabs__nav');
    if (!nav || nav.getAttribute('data-lego-delegation') === '1') {
      return;
    }
    nav.setAttribute('data-lego-delegation', '1');
    nav.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('.lego-tabs__tab[role="tab"]');
      if (!btn || !root.contains(btn)) {
        return;
      }
      var t = btn.getAttribute('data-tab');
      if (t) {
        setActiveTab(root, t);
      }
    });
  }

  function markInitDone(root) {
    if (!root) {
      return;
    }
    root.removeAttribute('data-lego-initializing');
    root.setAttribute('data-lego-initialized', 'true');
  }

  function initLegoTabs(root) {
    if (!root) {
      return;
    }
    if (root.getAttribute('data-lego-initialized') === 'true') {
      return;
    }
    if (root.getAttribute('data-lego-initializing') === '1') {
      return;
    }
    if (root.getAttribute('data-section-type') !== 'lego-tabs' && !root.classList.contains('lego-tabs')) {
      return;
    }

    root.setAttribute('data-lego-initializing', '1');
    var config = getConfig(root);

    bindTabDelegation(root);

    if (config.enableRecent) {
      var panelR = root.querySelector('.lego-tabs__panel--recent');
      loadRecentContent(root)
        .then(function (result) {
          var wait = root.querySelector('[data-lego-recent-wait]');
          if (wait) wait.setAttribute('hidden', '');
          if (panelR) panelR.classList.remove('is-loading');
          if (!result || !result.html) {
            removeRecentTabUI(root);
            activateDefaultCarousels(root, Object.assign({}, config, { enableRecent: false }));
          } else {
            var carousel = root.querySelector('[data-panel="recent"] .js-lego-tabs-carousel');
            if (carousel) {
              restoreRecentTabUI(root);
              carousel._legoTabsCellHtml = null;
              carousel._legoTabsCellsPerPage = null;
              carousel.innerHTML = result.html;
              var selectedTab = root.querySelector('.lego-tabs__tab[aria-selected="true"]');
              if (selectedTab && selectedTab.getAttribute('data-tab') === 'recent') {
                setActiveTab(root, 'recent');
              } else {
                var activePanel = root.querySelector('.lego-tabs__panel:not([hidden])');
                ensurePanelCarousel(activePanel);
              }
            }
          }
        })
        .catch(function (err) {
          if (window.console && typeof window.console.warn === 'function') {
            window.console.warn('[LegoTabs] Recently viewed failed to render', err);
          }
          var wait2 = root.querySelector('[data-lego-recent-wait]');
          if (wait2) wait2.setAttribute('hidden', '');
          if (panelR) panelR.classList.remove('is-loading');
          removeRecentTabUI(root);
          activateDefaultCarousels(root, Object.assign({}, config, { enableRecent: false }));
        })
        .then(function () {
          markInitDone(root);
        });
    } else {
      try {
        activateDefaultCarousels(root, config);
      } finally {
        markInitDone(root);
      }
    }
  }

  function onReady() {
    document.querySelectorAll('.lego-tabs[data-section-type="lego-tabs"]').forEach(function (root) {
      initLegoTabs(root);
    });
  }

  function refreshResponsiveCarousels() {
    document.querySelectorAll('.lego-tabs[data-section-type="lego-tabs"] .js-lego-tabs-carousel').forEach(function (carousel) {
      var previousCellsPerPage = carousel._legoTabsCellsPerPage;
      rebuildCarouselPages(carousel);
      if (
        typeof jQuery === 'function' &&
        previousCellsPerPage !== carousel._legoTabsCellsPerPage &&
        !carousel.closest('.lego-tabs__panel[hidden]')
      ) {
        ensureSlick(jQuery(carousel));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshResponsiveCarousels, 150);
  });

  function unslickCarouselsIn(root) {
    if (typeof jQuery === 'undefined' || !jQuery || !jQuery.fn || !jQuery.fn.slick) {
      return;
    }
    [].forEach.call(root.querySelectorAll('.js-lego-tabs-carousel.slick-initialized'), function (c) {
      try {
        jQuery(c).slick('unslick');
      } catch (e) {
        /* Slick or DOM in inconsistent state; safe to ignore on teardown */
      }
    });
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (!t || !t.querySelector) return;
    var r = t.querySelector('.lego-tabs[data-section-type="lego-tabs"]');
    if (r) {
      r.removeAttribute('data-lego-initialized');
      r.removeAttribute('data-lego-initializing');
      var nav = r.querySelector('.lego-tabs__nav');
      if (nav) {
        nav.removeAttribute('data-lego-delegation');
      }
      unslickCarouselsIn(r);
      initLegoTabs(r);
    }
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t || !t.querySelector) return;
    var r = t.querySelector && t.querySelector('.lego-tabs[data-section-type="lego-tabs"]');
    if (r) {
      unslickCarouselsIn(r);
    }
  });

  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) {
      return;
    }

    document.querySelectorAll('.lego-tabs[data-section-type="lego-tabs"]').forEach(function (root) {
      root.removeAttribute('data-lego-initialized');
      root.removeAttribute('data-lego-initializing');
      initLegoTabs(root);
    });
  });
})();
